import { Http, HttpResponse } from "@capacitor-community/http";
import { Capacitor } from "@capacitor/core";
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { _token, _onUnauthorized } from "./axiosConfig";

interface IApi{
    get(url: string, config?: AxiosRequestConfig): Promise<HttpResponse>;
    post(url: string, data?: any, config?: AxiosRequestConfig): Promise<HttpResponse>;
    put(url: string, data?: any, config?: AxiosRequestConfig): Promise<HttpResponse>;
    patch(url: string, data?: any, config?: AxiosRequestConfig): Promise<HttpResponse>;
    delete(url: string, config?: AxiosRequestConfig): Promise<HttpResponse>;
}
export class Api implements IApi{
    private static instance: Api;
    get(url: string, config?: any): Promise<HttpResponse> {return null};
    post(url: string, data?: any, config?: AxiosRequestConfig): Promise<HttpResponse>{return null};
    put(url: string, data?: any, config?: AxiosRequestConfig): Promise<HttpResponse>{return null};
    patch(url: string, data?: any, config?: AxiosRequestConfig): Promise<HttpResponse>{return null};
    delete(url: string, config?: AxiosRequestConfig): Promise<HttpResponse>{return null};

    public static getInstance(): Api {
        console.log(process.env.NODE_ENV);
        if (!Api.instance) {
            if(Capacitor.getPlatform() === 'web')
                Api.instance = new WebApi();
            else{
                //if developping, use WebApi for compatibility with localhost
                if(process.env.NODE_ENV === 'development')
                    Api.instance = new WebApi();
                else
                    Api.instance = new NativeApi();
            }
        }

        return Api.instance;
    }
    
}

class WebApi extends Api{
    
    private axiosInstance = (): AxiosInstance => {
        const instance = process.env.REACT_APP_API_ENDPOINT !== undefined
            ? axios.create({ headers: { "Authorization": `JWT ${_token}` }, baseURL: process.env.REACT_APP_API_ENDPOINT })
            : axios.create({ headers: { "Authorization": `JWT ${_token}` } });
        instance.interceptors.response.use(
            response => response,
            error => {
                if (error.response?.status === 401 && _onUnauthorized) {
                    _onUnauthorized();
                }
                return Promise.reject(error);
            }
        );
        return instance;
    };


    get(url: string, config?: any): Promise<HttpResponse> {
        return this.axiosInstance().get(url, config);
    }
    post<T = any, R = AxiosResponse<T>>(url: string, data?: any, config?: AxiosRequestConfig): Promise<R> {
        return this.axiosInstance().post(url, data, config);
    }
    put<T = any, R = AxiosResponse<T>>(url: string, data?: any, config?: AxiosRequestConfig): Promise<R> {
        return this.axiosInstance().put(url, data, config);
    }
    patch<T = any, R = AxiosResponse<T>>(url: string, data?: any, config?: AxiosRequestConfig): Promise<R> {
        return this.axiosInstance().patch(url, data, config);
    }
    delete<T = any, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
        return this.axiosInstance().delete(url, config);
    }


}

class NativeApi extends Api {
    private backendUrl = process.env.REACT_APP_API_ENDPOINT !== undefined ? 
                        process.env.REACT_APP_API_ENDPOINT :
                        "https://api.entralpi.com";
    //private backendUrl = "http://localhost:3001";
    get(url: string, config?: any): Promise<HttpResponse> {
        console.log(url);
        return new Promise<HttpResponse>((resolve, reject) => {
            Http.request({
                method: "GET",
                url: this.backendUrl+url,
                headers: { "Content-Type": "application/json",
                            "Authorization": `JWT ${_token}` },
                ...config
            }).then((data) => {
                console.log(data);
                if (data.status !== 200)
                    reject(data.status.toString());
                resolve(data);
            });
        });
    }
    post(url: string, data?: any, config?: AxiosRequestConfig): Promise<HttpResponse> {
 
        return new Promise<HttpResponse>((resolve, reject) => {
                console.log(this.backendUrl+url);
                Http.request({
                    method: "POST",
                    url: this.backendUrl+url,
                    headers: { "Content-Type": "application/json",
                    "Authorization": `JWT ${_token}` },
                    data: { ...data }
                }).then((data) => {
                    console.log(data);
                    if (data.status !== 200)
                        reject(data.status.toString());
                    resolve(data);
                });
            });
    }
    put(url: string, data?: any, config?: AxiosRequestConfig): Promise<HttpResponse> {
        return new Promise<HttpResponse>((resolve, reject) => {
            Http.request({
                method: "PUT",
                url: this.backendUrl+url,
                headers: { "Content-Type": "application/json",
                "Authorization": `JWT ${_token}` },
                data: { ...data }
            }).then((data) => {
                if (data.status !== 200)
                    reject(data.status.toString());
                resolve(data);
            });
        });
    }
    patch(url: string, data?: any, config?: AxiosRequestConfig): Promise<HttpResponse> {
        return new Promise<HttpResponse>((resolve, reject) => {
            Http.request({
                method: "PATCH",
                url: this.backendUrl+url,
                headers: { "Content-Type": "application/json",
                "Authorization": `JWT ${_token}` },
                data: { ...data }
            }).then((data) => {
                if (data.status !== 200)
                    reject(data.status.toString());
                resolve(data);
            });
        });
    }
    delete(url: string, config?: AxiosRequestConfig): Promise<HttpResponse> {
        return new Promise<HttpResponse>((resolve, reject) => {
            Http.request({
                method: "DELETE",
                url: this.backendUrl+url,
                headers: { "Content-Type": "application/json",
                "Authorization": `JWT ${_token}` },
            }).then((data) => {
                if (data.status !== 200)
                    reject(data.status.toString());
                resolve(data);
            });
        });
    }

}